import React from 'react';
import { CircleFlag } from 'react-circle-flags';

export const CurrencyDiv = ({
  currency,
  className,
}: {
  currency: string;
  className?: string;
}) => {
  return (
    <div className={`flex flex-row items-center w-full gap-2 ${className}`}>
      <CircleFlag
        countryCode={currency?.substring(0, 2)?.toLowerCase()}
        width="20"
      />
      <p className="paragraph-sm-medium text-greyscale-text-title">
        {currency}
      </p>
    </div>
  );
};
